import { useThemeProps } from "@mui/material";
import React from "react";

import { ShapeIconRoot } from "./style";

interface ShapeIconProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: React.ReactNode;
    children?: React.ReactNode;
    variant?: "default" | "contrast" | "outline";
    size?: "2xsmall" | "xsmall" | "small" | "medium" | "large" | "xlarge";
    color?: "gray" | "accent" | "error" | "warning" | "success" | "oceanGreen" | "indigo" | "purple";
}

export interface ShapeIconOwnerState extends ShapeIconProps {}

export const ShapeIcon: React.ForwardRefExoticComponent<ShapeIconProps & React.RefAttributes<HTMLDivElement>> =
    React.forwardRef<HTMLDivElement, ShapeIconProps>(function ShapeIcon(inProps, ref) {
        const props = useThemeProps({ props: inProps, name: "MuiShapeIcon" });
        const { variant = "default", size = "small", color = "gray", ...other } = props;
        const ownerState = { ...props, variant, size, color };
        return (
            <ShapeIconRoot {...other} ownerState={ownerState} ref={ref}>
                {other.icon}
                {other.children}
            </ShapeIconRoot>
        );
    });
